/* eslint-disable no-use-before-define */
import emitter from './emitter';

function accessResult(ctx, endpoint, input, options) {
  const {
    cache: { entries },
  } = ctx;
  let entriesForResource = entries.get(endpoint);
  const now = Date.now();

  if (entriesForResource === undefined) {
    entriesForResource = new Map();
    entries.set(endpoint, entriesForResource);
  }

  const key = options.stringifyInput(input);
  const entry = entriesForResource.get(key);

  if (entry === undefined || (!entry.promise && !entry.error && entry.value === undefined)) {
    const thenable = endpoint(input);
    const newEntry = {
      value: undefined,
      promise: thenable,
      error: null,
      fetchedAt: now,
      resolvedAt: null,
      cacheTime: options.cacheTime,
      queuedRefetch: false,
      version: 1,
      key,
    };
    thenable.then(
      value => {
        if (newEntry.promise) {
          const resolvedResult = newEntry;
          resolvedResult.promise = null;
          resolvedResult.value = value ?? null;
          resolvedResult.resolvedAt = Date.now();
          resolvedResult.version++;
        }
        if (!options.suspense) {
          Promise.resolve().then(() => emitter.emit('update', { endpoint }));
        }
      },
      error => {
        if (newEntry.promise) {
          const rejectedResult = newEntry;
          rejectedResult.promise = null;
          rejectedResult.error = error;
          rejectedResult.version++;
        }
        if (!options.suspense) {
          Promise.resolve().then(() => emitter.emit('update', { endpoint }));
        }
      },
    );
    entriesForResource.set(key, newEntry);
    return newEntry;
  }

  if (
    now >= entry.fetchedAt + entry.cacheTime * 1000 ||
    (entry.error && now >= entry.fetchedAt + 10000)
  ) {
    if (entry.promise) {
      // If an endpoint was invalidated when a refetch is in progress
      // queue another refetch after the current one completes
      entry.queuedRefetch = true;
    } else {
      refetch(entry, endpoint, input, options, now);
    }
  }

  return entry;
}

function refetch(entry, endpoint, input, options, now) {
  const thenable = endpoint(input).then(r => {
    if (entry.queuedRefetch) {
      entry.queuedRefetch = false;
      return refetch(entry, endpoint, input, options, Date.now());
    }
    return r;
  });
  entry.promise = thenable;
  entry.fetchedAt = now;
  entry.error = null;
  entry.cacheTime = options.cacheTime;

  thenable.then(
    value => {
      if (entry.promise) {
        entry.value = value;
        entry.resolvedAt = Date.now();
        entry.promise = null;
        entry.version++;
      }
      Promise.resolve().then(() => emitter.emit('update', { endpoint }));
    },
    error => {
      if (entry.promise) {
        entry.error = error;
        entry.promise = null;
        entry.version++;
      }
      Promise.resolve().then(() => emitter.emit('update', { endpoint }));
    },
  );

  return thenable;
}

export default accessResult;
